import React, { useState } from 'react';
import { ModalBg } from '@/components/BaseModal/ModalBg';
import { PacsButton } from '@/components/common/PacsButton';
import { AccountListViewModel } from '@/viewModel/setting/AccountListViewModel';
import { Radio } from '@mantine/core';

type Props = {
  accountListViewModel?: AccountListViewModel;
  handleClose?: () => Promise<void> | void;
  onChangeShareLinkPermission?: (canCreateShareLink: boolean) => Promise<void> | void;
};

export const AskChangeShareLinkPermissionModal = ({
  accountListViewModel = new AccountListViewModel(),
  handleClose = () => {},
  onChangeShareLinkPermission = () => {},
}: Props) => {
  const [canCreateShareLink, setCanCreateShareLink] = useState<boolean>(accountListViewModel.getSelectedAccountItem()?.can_create_share_link || false);

  /**
   * 選擇選項
   */
  const handleCheckOption = (enabled: boolean) => {
    setCanCreateShareLink(enabled);
  };

  /**
   * 按下確認
   */
  const handleConfirm = () => {
    onChangeShareLinkPermission(canCreateShareLink);
  };

  return (
    <ModalBg>
      <div className="appear_top pwd_modal relative w-full max-w-[480px] max-h-[90%] bg-green-182c2a overflow-hidden hidden-overflow-with-radius rounded-[16px] px-[48px] py-[36px]">
        <div className="w-full flex flex-col i-center text-white">
          <h3 className="text-gray-f9f9f9 mb-[28px] text-center">
            Do you want to change the share link creation permission?
          </h3>

          <div className="mb-[28px]">
            <Radio
              label="Enable"
              className="mb-[18px]"
              checked={canCreateShareLink}
              onChange={() => handleCheckOption(true)}
            />
            <Radio
              label="Disable"
              checked={!canCreateShareLink}
              onChange={() => handleCheckOption(false)}
            />
          </div>

          <PacsButton
            className="block w-full h-[40px] mb-[8px]"
            onClick={handleConfirm}
          >
            <span className="text-green-182c2a font-bold">Confirm</span>
          </PacsButton>
          <PacsButton
            theme="secondary"
            className="block w-full h-[40px] font-bold"
            onClick={handleClose}
          >
            Cancel
          </PacsButton>
        </div>
      </div>
    </ModalBg>
  );
};
